import { render, staticRenderFns } from "./AdmissionsListPerStudent.vue?vue&type=template&id=486a15e1"
import script from "./AdmissionsListPerStudent.vue?vue&type=script&lang=js"
export * from "./AdmissionsListPerStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports